import { hasRole, hasPermission, hasOrganisation } from 'utils/authentication'

export default {
  methods: {
    hasRole,
    hasPermission,
    hasOrganisation
  }
}
